import { getRandomIntInclusive } from '@application/utils';
import { InputLabel, InputWrapper, SkeletonBox } from '@presentation/components';
import { useMemo } from 'react';
import * as Styled from './styled';

export const PageSkeleton = () => {
  const skeletons = useMemo(() => ({
    form: {
      section1: {
        image: {
          label: { width: `${getRandomIntInclusive(30, 40)}%`, height: 15 },
          inputField: { width: `${getRandomIntInclusive(70, 90)}%`, height: 300 },
        },
        fields: Array(4)
          .fill(undefined)
          .map(() => ({
            label: { width: `${getRandomIntInclusive(30, 40)}%`, height: 15 },
            inputField: { width: `${getRandomIntInclusive(30, 90)}%`, height: 35 },
          }))
      },
      section2: {
        fields: Array(2)
          .fill(undefined)
          .map(() => ({
            label: { width: `${getRandomIntInclusive(30, 40)}%`, height: 15 },
            inputField: { width: `${getRandomIntInclusive(70, 90)}%`, height: 35 },
          }))
      },
    }
  }), []);

  return (
    <>
      <div>
        <InputWrapper split>
          <InputWrapper>
            <InputLabel>
              <SkeletonBox style={skeletons.form.section1.image.label} />
            </InputLabel>
            <Styled.ImageWrapperContainer>
              <Styled.ImageWrapper>
                <SkeletonBox style={skeletons.form.section1.image.inputField} />
              </Styled.ImageWrapper>
            </Styled.ImageWrapperContainer>
          </InputWrapper>
        </InputWrapper>

        <InputWrapper split last>
          {
            skeletons.form.section1.fields.map((field, index) => (
              <InputWrapper key={index}>
                <InputLabel required>
                  <SkeletonBox style={field.label} />
                </InputLabel>
                <SkeletonBox style={field.inputField} />
              </InputWrapper>
            ))
          }
        </InputWrapper>
      </div>

      <>
        {
          skeletons.form.section2.fields.map((field, index) => (
            <InputWrapper key={index} split last={index%2 === 0}>
              <InputLabel required>
                <SkeletonBox style={field.label} />
              </InputLabel>
              <SkeletonBox style={field.inputField} />
            </InputWrapper>
          ))
        }
      </>
    </>
  );
};
